
<template>
  <div class="selectBox">
    <el-select
      v-model="selectedValue"
      clearable
      placeholder="请选择"
      :disabled="disabled"
      @change="handleChange"
    >
      <el-option
        v-for="item in itemsData"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      />
    </el-select><el-button
      v-if="addClient"
      type="primary"
      size="small"
      @click="handleAddComboxData()"
    >
      自定义
    </el-button>
    <el-dialog
      title="新增下拉框数据"
      :visible.sync="addItemDailogShow"
      width="20%"
      :before-close="handleCloseDailog"
      @open="handleOpenDailog"
    >
      <el-form
        ref="newItemData"
        :model="newItemData"
        :rules="rules"
        label-width="100px"
        :inline="true"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item
              label="名称"
              prop="itemName"
              style="width:100%"
            >
              <el-input
                v-model="newItemData.itemName"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="handleCloseDailog">取 消</el-button>
        <el-button
          type="primary"
          @click="handleSaveData"
        >保  存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import pathReq from '@/api/pathlist'
import LoadingOptions from '@/components/commonSetting'

export default {
  components: {
  },
  props: {
    value: { type: String, default: '' },
    typeId: { type: String, default: '' },
    optionData: { type: Array, default: null },
    addClient: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {
      title: '下拉框',
      selectedValue: '',
      itemsData: [],
      addItemDailogShow: false,
      newItemData: {
        dictTypeId: '',
        itemName: ''
      },
      rules: {
        itemName: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
  },
  watch: {
    value: function(newVal) {
      this.selectedValue = newVal
    },
    optionData: function(newVal) {
      this.itemsData = newVal
    }
  },
  created() {
  },
  mounted() {
  },
  activated() {

  },
  methods: {
    handleChange() {
      // alert(this.selectedValue)
      this.$emit('input', this.selectedValue)
      this.$emit('handleChange')
    },
    handleAddComboxData() {
      this.newItemData.dictTypeId = this.typeId

      this.addItemDailogShow = true
    },
    handleOpenDailog() {},
    handleCloseDailog() {
      this.addItemDailogShow = false
    },
    handleSaveData() {
      this.$refs.newItemData.validate(valid => {
        if (valid) {
          const loading = this.$loading(LoadingOptions.loadOptions)
          pathReq
            .postForm('/api/services/app/Com/AddDictItemByUser', this.newItemData)
            .then((res) => {
              this.newItemData = {}
              loading.close()
              this.$message.success('自定义下拉框内容成功')
              this.itemsData = res.data.result.allData
              this.selectedValue = res.data.result.newId
              this.addItemDailogShow = false
            })
        } else {
          return false
        }
      })
    }

  }
}
</script>
<style>
.selectBox {
  display: flex;
  flex-direction: row;

}
.selectBox  .el-button {
  margin-left: 5px;
}
</style>
